import { html, ref } from '@microsoft/fast-element';
import type { MarketPerformanceGraph } from './market-performance-graph';
export const MarketPerformanceGraphTemplate = html<MarketPerformanceGraph>`
  <div class="graph-div">
    <div
      class="graph-div"
      style="display: ${(x) => (x.historicalData.length > 0 ? 'inline' : 'none')}"
      ${ref('marketPerformanceChart')}
    ></div>
    <div
      class="graph-div"
      style="display: ${(x) => (x.historicalData.length > 0 ? 'none' : 'inline')}"
    >
      <p class="centered-text">No Hub/Zone data to display</p>
    </div>
  </div>
`;
